import { render, staticRenderFns } from "./HitRowDetails.vue?vue&type=template&id=53404d9f"
import script from "./HitRowDetails.vue?vue&type=script&lang=ts"
export * from "./HitRowDetails.vue?vue&type=script&lang=ts"
import style0 from "./HitRowDetails.vue?vue&type=style&index=0&id=53404d9f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports